import React from 'react';
import cn from 'classnames';

import s from './styles.module.css';

interface Props {
  // 0..1
  progress: number;
  className?: string;
}

const ProgressLine: React.FC<Props> = React.memo(({ progress, className }) => (
  <div className={cn(s.progressWrapper, className)} data-test-id="progress-line">
    <div className={s.progress} style={{ width: `${progress * 100}%` }} />
  </div>
));

ProgressLine.displayName = 'ProgressLine';

export { ProgressLine };
